export default "__VITE_ASSET__OTDCaFGC__";